import {setCookie, getCookie, deleteCookie} from './cookies';

export default class {
  constructor(cookieName,
              cookieDuration,
              modalStatus = false,
              requireUserLoggedIn = false,
              modalId,
              showModalAfter = 15000
  ) {

    this.userLoggedIn = ajax_object.modal.logged_in || false;
    this.modal = document.getElementById(modalId);

    if(false === requireUserLoggedIn) {
      // Do nothing, since we're already logged in
      if(this.userLoggedIn || !this.modal) {
        return;
      }
    } else {
      // Do nothing
      if(!this.userLoggedIn || !this.modal) {
        return;
      }
    }

    this.cookieName = cookieName;
    this.cookieDuration = cookieDuration;

    if(true === modalStatus) {
      this.status = ajax_object.modal.status || false;

      // Flush cookies when no cookie is allowed.
      if (!this.status) {
        this.flushCookies();
        return;
      }
    }

    if (!getCookie(this.cookieName)) {
      let self = this;
      setTimeout(function () {
        self.showModal();
      }, showModalAfter);
    }
  }

  /**
   * No modal, clear all cookies
   */
  flushCookies() {
    if (getCookie(this.cookieName)) {
      deleteCookie(this.cookieName);
    }
  }

  /**
   * Trigger modal & set cookie
   */
  showModal() {
    jQuery(this.modal).modal('show');
    setCookie(this.cookieName, 1, this.cookieDuration);
  }
}
